import * as moment from 'moment';
import { Component, OnInit, Input, OnDestroy, OnChanges } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { UntypedFormControl, Validators } from '@angular/forms';
import { CampaignService } from '../../services/campaign.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-campaign-puja-settings',
  templateUrl: './campaign-puja-settings.component.html',
  styleUrls: ['./campaign-puja-settings.component.scss']
})
export class CampaignPujaSettingsComponent implements OnInit, OnChanges, OnDestroy {

  @Input() formGroupPresetOption: any = null;

  public frequencies: any[] = [
    { id: 1, label: 'One Time', value: 0 },
    { id: 2, label: 'Weekly', value: 2 },
    { id: 3, label: 'Monthly', value: 3 },
    { id: 6, label: 'Choose dates', value: 6 },
  ];

  public optionDayList: any[] = [
    { id: 1, label: 'Schedule immediately', value: 0 },
    { id: 2, label: 'Specific date', value: 1 },
    { id: 3, label: 'User selected date', value: 2 }
  ];

  public dayList: any[] = [
    { id: 1, label: 'Sunday', value: 0 },
    { id: 2, label: 'Monday', value: 1 },
    { id: 3, label: 'Tuesday', value: 2 },
    { id: 4, label: 'Wednesday', value: 3 },
    { id: 5, label: 'Thursday', value: 4 },
    { id: 6, label: 'Friday', value: 5 },
    { id: 7, label: 'Saturday', value: 6 },
  ];

  public pakshaList: any[] = [
    { id: 1, label: 'Sukla Paksha', value: 1 },
    { id: 2, label: 'Krishna Paksha', value: 2}
  ];

  public tithiList: any[] = [
    { id: 1, label: 'Pratipat', value: 1 },
    { id: 2, label: 'Dwitiya', value: 2 },
    { id: 3, label: 'Tritiya', value: 3 },
    { id: 4, label: 'Chaturthi', value: 4 },
    { id: 5, label: 'Panchami', value: 5 },
    { id: 6, label: 'Shashthi', value: 6 },
    { id: 7, label: 'Sapthami', value: 7 },
    { id: 8, label: 'Ashtami', value: 8 },
    { id: 9, label: 'Navami', value: 9 },
    { id: 10, label: 'Dasami', value: 10 },
    { id: 11, label: 'Ekadasi', value: 11 },
    { id: 12, label: 'Dwadasi', value: 12 },
    { id: 13, label: 'Trayodasi', value: 13 },
    { id: 14, label: 'Chaturdasi', value: 14 },
    { id: 15, label: 'Pournimasya', value: 15 },
    { id: 16, label: 'Amavasya', value: 16 }
  ];

  public initDate = new Date();
  public resetDate = new Date(0);
  public dates = [];

  public offeredFor = false;

  public takeUntilSubject: Subject<any> = new Subject();
  
  constructor(
    private campaignService: CampaignService
  ) {
  }

  ngOnInit(): void {
    this.reNgOnInit();
  }

  ngOnChanges(): void {
    this.reNgOnInit();
  }

  reNgOnInit(): void {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();

    this.takeUntilSubject = new Subject();
    
    const recurrence = this.formGroupPresetOption.get('recurrence') as UntypedFormControl;
    const optionDay = this.formGroupPresetOption.get('optionDay') as UntypedFormControl;
    const pujaDate = this.formGroupPresetOption.get('pujaDate') as UntypedFormControl;
    const weekDay = this.formGroupPresetOption.get('weekDay') as UntypedFormControl;
    const dateOfMonth = this.formGroupPresetOption.get('dateOfMonth') as UntypedFormControl;
    const hinduDatePaksha = this.formGroupPresetOption.get('hinduDatePaksha') as UntypedFormControl;
    const hinduDateTithi = this.formGroupPresetOption.get('hinduDateTithi') as UntypedFormControl;
    const pujaMultiDates = this.formGroupPresetOption.get('pujaMultiDates') as UntypedFormControl;
    const offeredForWeekCheckbox = this.formGroupPresetOption.get('offeredForWeekCheckbox') as UntypedFormControl;
    const offeredForWeekInput = this.formGroupPresetOption.get('offeredForWeekInput') as UntypedFormControl;
    const offeredForMonthCheckbox = this.formGroupPresetOption.get('offeredForMonthCheckbox') as UntypedFormControl;
    const offeredForMonthInput = this.formGroupPresetOption.get('offeredForMonthInput') as UntypedFormControl;
    const offeredForYearCheckbox = this.formGroupPresetOption.get('offeredForYearCheckbox') as UntypedFormControl;
    const offeredForYearInput = this.formGroupPresetOption.get('offeredForYearInput') as UntypedFormControl;

    recurrence.valueChanges.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe(value => {
      /** One Time **/
      optionDay.setValue(0);

      /** Weekly **/
      weekDay.setValue(0);

      /** Monthly */
      const dateOfMonthValue = moment().format("MM/DD/YYYY");
      dateOfMonth.setValue(dateOfMonthValue);

      /** Hindu */
      hinduDatePaksha.clearValidators();
      hinduDatePaksha.setValue(1);

      hinduDateTithi.clearValidators();
      hinduDateTithi.setValue(1);

      /** Choose Dates */
      this.dates = [];
      pujaMultiDates.clearValidators();
      pujaMultiDates.setValue([]);

      /** Offered For */
      offeredForWeekCheckbox.enable();
      offeredForWeekCheckbox.setValue(false);
      offeredForWeekInput.setValue('');
      offeredForMonthCheckbox.setValue(false);
      offeredForMonthInput.setValue('');
      offeredForYearCheckbox.setValue(false);
      offeredForYearInput.setValue('');


      switch(value) {
        case 0:
          this.offeredFor = false;
          this.formGroupPresetOption.get('offeredFor').setValue(false);
          break;
        case 2:
          this.offeredFor = true;
          this.formGroupPresetOption.get('offeredFor').setValue(true);
          break;
        case 3:
          this.offeredFor = true;
          this.formGroupPresetOption.get('offeredFor').setValue(true);
          offeredForWeekCheckbox.disable();
          break;
        case 4:
          hinduDatePaksha.setValidators([Validators.required]);
          hinduDateTithi.setValidators([Validators.required]);
          this.offeredFor = true;
          this.formGroupPresetOption.get('offeredFor').setValue(true);
          offeredForWeekCheckbox.disable();
        case 5:
          hinduDateTithi.setValidators([Validators.required]);
          this.offeredFor = true;
          this.formGroupPresetOption.get('offeredFor').setValue(true);
          offeredForWeekCheckbox.disable();
          break;
        case 6:
          pujaMultiDates.setValidators([Validators.required]);
          this.offeredFor = false;
          this.formGroupPresetOption.get('offeredFor').setValue(false);
          break;
      }
    });

    optionDay.valueChanges.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe(value => {
      const { formGroupPresetOption } = this;
      const dateRequired = formGroupPresetOption.get('dateRequired') as UntypedFormControl;
      const pujaDate = formGroupPresetOption.get('pujaDate') as UntypedFormControl;
      switch(value) {
        case 0:
          dateRequired.setValue(false);
          pujaDate.setValue(moment(978300000000).format('MM/DD/YYYY'));
          pujaDate.clearValidators();
          break;
        case 1:
          dateRequired.setValue(false);
          pujaDate.setValue(moment().format("MM/DD/YYYY"));
          pujaDate.setValidators([Validators.required]);
          break;
        case 2:
          dateRequired.setValue(true);
          pujaDate.setValue(moment(978300000000).format('MM/DD/YYYY'));
          pujaDate.clearValidators();
          break;
      }
    });

    this.campaignService.configGroup(this.formGroupPresetOption, this.formGroupPresetOption, {
      name: 'offeredForWeekCheckbox',
      value: true
    }, [
      { name: 'offeredForWeekInput', defaultValue: 0, validators: [Validators.required, Validators.min(1)] },
    ], this.takeUntilSubject);

    this.campaignService.configGroup(this.formGroupPresetOption, this.formGroupPresetOption, {
      name: 'offeredForMonthCheckbox',
      value: true
    }, [
      { name: 'offeredForMonthInput', defaultValue: 0, validators: [Validators.required, Validators.min(1)] },
    ], this.takeUntilSubject);

    this.campaignService.configGroup(this.formGroupPresetOption, this.formGroupPresetOption, {
      name: 'offeredForYearCheckbox',
      value: true
    }, [
      { name: 'offeredForYearInput', defaultValue: 0, validators: [Validators.required, Validators.min(1)] },
    ], this.takeUntilSubject);

    this.dates = pujaMultiDates.value;

    switch(recurrence.value) {
      case 3:
      case 5:
        hinduDatePaksha.setValidators([Validators.required]);
      case 4:
        hinduDateTithi.setValidators([Validators.required]);
        offeredForWeekCheckbox.disable();
        break;
    }

    if(optionDay.value == 1) {
      const pujaDate = this.formGroupPresetOption.get('pujaDate') as UntypedFormControl;
      pujaDate.setValidators([Validators.required]);
    }
  }

  ngOnDestroy(): void {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }

  public dateClass = (date: Date) => {
    const index = this.dates.map((m) => +m).indexOf(+date);
    if (index !== -1) {
      return [ 'selected' ];
    }
    return [ ];
  }

  public onDateChange(event: MatDatepickerInputEvent<Date>): void {
    if (event.value) {
      const date = event.value;
      const index = this.dates.map((m) => +m).indexOf(+date);
      if (index === -1) {
        this.dates.push(date);
      } else {
        this.dates.splice(index, 1)
      }
      this.resetDate = new Date(0);
    }

    const pujaMultiDates = this.formGroupPresetOption.get('pujaMultiDates') as UntypedFormControl;
    pujaMultiDates.setValue(this.dates);
  }

  public remove(date: Date): void {
    const index = this.dates.map((m) => +m).indexOf(+date);
    this.dates.splice(index, 1);

    const pujaMultiDates = this.formGroupPresetOption.get('pujaMultiDates') as UntypedFormControl;
    pujaMultiDates.setValue(this.dates);
  }

}
